import React, { Component } from 'react';
import qs from 'qs';
import PropTypes from 'prop-types';
import DiscussionCreator from './DiscussionCreator';
import PushParamDropdown from './PushParamDropdown';
import ModalTrigger from './ModalTrigger';
import Breadcrumbs from './Breadcrumbs';

export default class DiscussionListHeader extends Component {
  static propTypes = {
    apiUrl: PropTypes.string.isRequired,
    ontology: PropTypes.object.isRequired,
    currentCommunityName: PropTypes.string.isRequired,
    currentCommunityPopulation: PropTypes.number.isRequired,
    currentUser: PropTypes.object.isRequired,
    currentUserIsStaff: PropTypes.bool.isRequired,
    apiUserUrl: PropTypes.string,
    apiCompanyUrl: PropTypes.string,
    buttonCopy: PropTypes.string,
    expanded: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    currentCommunity: {},
    currentCommunityPopulation: 0,
    apiUserUrl: '',
    apiCompanyUrl: '',
    buttonCopy: 'Start a discussion',
  };

  constructor(props) {
    super(props);

    this.state = {
      clicked: false,
    };
  }

  handleClick = () => {
    this.setState({ clicked: true });
  };

  handleNewDiscussionBlur = () => {
    this.setState({ clicked: false });
  };

  expand = (e) => {
    e.preventDefault();
    this.handleViewChange(true);
  };

  compact = (e) => {
    e.preventDefault();
    this.handleViewChange(false);
  };

  handleViewChange = (expanded) => {
    const output = { expanded };
    const params = Object.assign(qs.parse(window.location.search.slice(1)), output);
    const search = qs.stringify(params, { arrayFormat: 'brackets' });
    router.push({ pathname: location.pathname, search });
  };

  render() {
    const activeClasses = [
      'u-bg-old-primary-color-blue',
      'u-text-white',
      'hover:u-bg-link-hover',
      'hover:u-border-link-hover',
      'hover:u-text-white',
      'focus:u-text-white',
    ];
    const inactiveClasses = [
      'u-bg-white',
      'u-text-old-primary-color-blue',
      'hover:u-bg-grey-lightest',
      'hover:u-border-link-hover',
    ];
    const firstClass = ['u-rounded-l'];
    const lastClass = ['u-rounded-r'];
    const regularClasses = [
      'u-text-2xl',
      'md:u-text-lg',
      'u-h-11',
      'u-w-11',
      'md:u-w-8',
      'md:u-h-8',
      'u-flex',
      ,
      'u-border',
      'u-border-old-primary-color-blue',
      'u-items-center',
      'u-justify-center',
    ];

    let listClasses = regularClasses.concat(firstClass);
    let cardClasses = regularClasses.concat(lastClass);
    let listIcon = null;
    let cardIcon = null;

    if (this.props.expanded) {
      listClasses = listClasses.concat(inactiveClasses);
      cardClasses = cardClasses.concat(activeClasses);
      listIcon = 'Icon-list-hollow';
      cardIcon = 'Icon-card';
    } else {
      listClasses = listClasses.concat(activeClasses);
      cardClasses = cardClasses.concat(inactiveClasses);
      listIcon = 'Icon-list';
      cardIcon = 'Icon-card-hollow';
    }

    return (
      <div className="u-flex u-justify-between u-items-center u-mb-4 md:u-mb-5 u-relative u-flex-col md:u-flex-row">
        <div className="u-flex u-items-center u-flex-grow u-mb-4 md:u-w-auto md:u-mb-0">
          {/* Hide the breadcrumbs on mobile */}
          <div className="u-hidden md:u-block u-flex-grow">
            <Breadcrumbs items={[{ title: 'Discussions', link: null }]} />
          </div>

          <button
            onClick={this.handleClick}
            className="u-py-2 u-leading-tight u-text-base u-font-semibold u-btn u-btn-primary md:u-mr-2 md:u-text-sm">
            {this.props.buttonCopy}
          </button>
        </div>

        <div className="u-flex u-items-center u-justify-between u-w-full u-max-w-full md:u-w-auto">
          <div className="u-flex u-mr-3 md:u-mr-0">
            <a onClick={this.compact} href="?expanded=false" className={listClasses.join(' ')}>
              <i className={listIcon} />
            </a>
            <a onClick={this.expand} href="?expanded=true" className={cardClasses.join(' ')}>
              <i className={cardIcon} />
            </a>
          </div>

          <div className="md:u-hidden u-flex-grow">
            <PushParamDropdown
              wrapperClass="u-relative u-w-full u-block"
              triggerClass="u-block u-text-left u-w-full u-pl-2 u-h-11"
              defaultOption="newest"
              selectedOption={this.props.selectedOption}
              queryName="sort"
              displayPrefix="Sort by:"
              items={this.props.sortItems}
              options={this.props.sortOptions}
            />
          </div>
        </div>
        {this.state.clicked && (
          <div className="u-absolute u-top-0 u-left-0 u-right-0 u-mt-15 u-z-200">
            <DiscussionCreator
              apiUrl={this.props.apiUrl}
              contextName={this.props.currentCommunityName}
              contextPopulation={this.props.currentCommunityPopulation}
              ontology={this.props.ontology}
              currentUser={this.props.currentUser}
              currentUserIsStaff={this.props.currentUserIsStaff}
              apiUserUrl={this.props.apiUserUrl}
              apiCompanyUrl={this.props.apiCompanyUrl}
              onBlur={this.handleNewDiscussionBlur.bind(this)}
              focus
            />
          </div>
        )}
      </div>
    );
  }
}
